import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import { closeModal, sendEmail } from "../../actions";
import styles from "../../components/Modal.module.css";

export class SendEmailModal extends Component {
  constructor(props) {
    super(props);
    this.send = this.send.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.handleType = this.handleType.bind(this);
    this.handleVarChange = this.handleVarChange.bind(this);
    this.nameRef = createRef();

    this.state = {
      sending: false,
      email: props.emailAddress,
      var: "",
    };
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  handleType(e) {
    this.setState({
      email: e.target.value,
    });
  }

  handleVarChange(e) {
    this.setState({
      var: e.value,
    });
  }

  send() {
    const { accountId, id } = this.props;

    if (this.state.sending) {
      return false;
    }

    this.setState({
      sending: true,
    });

    this.props
      .sendEmail(accountId, id, this.state.email, this.state.var)
      .then(this.props.closeModal);
  }

  setEmail(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ email: "dm-test@feed-london.com" });
  }

  renderTemplateOption(template) {
    return (
      <option value={template.id} key={template.id}>
        {template.name}
      </option>
    );
  }

  render() {
    const { translations } = this.props;

    const selectTranslation = translations ? (
      <div className={styles.flex}>
        <label>Translation</label>
        <select onChange={this.handleVarChange}>
          <option value="">All</option>
          {Object.keys(translations).map((key) => {
            return (
              <option key={key} value={key}>
                {key}
              </option>
            );
          })}
        </select>
      </div>
    ) : (
      <input type="hidden" value="" />
    );

    return (
      <Modal>
        <ModalHeader>Send Email</ModalHeader>
        <ModalContent>
          <form onSubmit={this.send}>
            {selectTranslation}
            <div className={styles.flex}>
              <label>Email Address</label>
              <input
                value={this.state.email}
                onChange={this.handleType}
                ref={this.nameRef}
                autoFocus
              />
            </div>
            <div className={styles.flex}>
              <label></label>
              <a className={styles.emailButton} onClick={this.setEmail}>
                dm-test@feed-london.com
              </a>
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          {this.state.sending ? (
            <Button color="greyed">
              <Icon icon="refresh" spin="true" /> Sending...
            </Button>
          ) : (
            <Button onClick={this.send}>Send</Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

SendEmailModal.propTypes = {
  sendEmail: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  key: PropTypes.string,
  accountId: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id, translations } = params;
  const emailAddress = state.auth.identity.username;

  return {
    emailAddress,
    translations,
    accountId,
    id,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  sendEmail,
})(SendEmailModal);
